<template>
    <div class="section-other-service">
        <div class="container">
            <div class="row justify-content-center">
                <div class="title">
                    <h3 class="h1 p-title p-black p-center mb-0 relawayBold">Our other services</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-4">
                    <div class="service-item">
                        <div class="service-title">
                            <p class="relawaySM p-black med"><b>Some service name</b></p>
                        </div>
                        <p class="min">In addition to the price you pay for the electricity you use, you must pay a so-called network fee.</p>
                        <div class="service-link">

                                <a href="#" class="return_link">See more
                                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z" fill="#1B98BE" stroke="#1B98BE" stroke-width="0.2"/>
                                    </svg>
                                </a>

                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="service-item">
                        <div class="service-title">
                            <p class="relawaySM p-black med"><b>Some service name</b></p>
                        </div>
                        <p class="min">In addition to the price you pay for the electricity you use, you must pay a so-called network fee.</p>
                        <div class="service-link">

                            <a href="#" class="return_link">See more
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z" fill="#1B98BE" stroke="#1B98BE" stroke-width="0.2"/>
                                </svg>
                            </a>

                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="service-item">
                        <div class="service-title">
                            <p class="relawaySM p-black med"><b>Some service name</b></p>
                        </div>
                        <p class="min">In addition to the price you pay for the electricity you use, you must pay a so-called network fee.</p>
                        <div class="service-link">

                            <a href="#" class="return_link">See more
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z" fill="#1B98BE" stroke="#1B98BE" stroke-width="0.2"/>
                                </svg>
                            </a>

                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="service-item">
                        <div class="service-title">
                            <p class="relawaySM p-black med"><b>Some service name</b></p>
                        </div>
                        <p class="min">In addition to the price you pay for the electricity you use, you must pay a so-called network fee.</p>
                        <div class="service-link">

                            <a href="#" class="return_link">See more
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z" fill="#1B98BE" stroke="#1B98BE" stroke-width="0.2"/>
                                </svg>
                            </a>

                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="service-item">
                        <div class="service-title">
                            <p class="relawaySM p-black med"><b>Some service name</b></p>
                        </div>
                        <p class="min">In addition to the price you pay for the electricity you use, you must pay a so-called network fee.</p>
                        <div class="service-link">

                            <a href="#" class="return_link">See more
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z" fill="#1B98BE" stroke="#1B98BE" stroke-width="0.2"/>
                                </svg>

                            </a>

                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="service-item">
                        <div class="service-title">
                            <p class="relawaySM p-black med"><b>Some service name</b></p>
                        </div>
                        <p class="min">In addition to the price you pay for the electricity you use, you must pay a so-called network fee.</p>
                        <div class="service-link">

                            <a href="#" class="return_link">See more
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z" fill="#1B98BE" stroke="#1B98BE" stroke-width="0.2"/>
                                </svg>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "otherService"
    }
</script>
